import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const styles = () => ({
  '@keyframes bgAnimation': {
    from: {
      transform: 'translate3d(20vw, -20vh, 0) rotate(-40deg)',
    },
    to: {
      transform: 'translate3d(100vw, -100vh, 0) rotate(-40deg)',
    },
  },
  wrapper: {
    width: '100%',
    height: '100%',
  },
  textContainer: {
    zIndex: 1,
    position: 'relative',
    padding: '1.5em',
    maxWidth: 600,
    '& h1': {
      margin: 0,
      fontSize: '3em',
      textTransform: 'uppercase',
    },
    '& h2': {
      color: '#CCCCCC',
      fontWeight: 300,
      fontSize: '1.5em',
    },
  },
  animatedBg: {
    zIndex: 0,
    position: 'relative',
    width: '300vw',
    height: '100vh',
    backgroundImage: 'url(/assets/images/notfoundgnome.png)',
    transform: 'translate3d(20vw, -20vh, 0) rotate(-40deg)',
    left: '-100%',
    top: '5%',
    animation: [['bgAnimation', 'linear', '30s']],
    animationIterationCount: 'infinite',
    transformOrigin: [['50%', '50%']],
    backgroundPosition: [['bottom', 'right']],
    backgroundSize: 'contain',
  },
  progress: {
    zIndex: 1,
    position: 'relative',
  },
});

const NotFoundPageComponent = ({ classes }) => (
  <div className={classes.wrapper}>
    <LinearProgress className={classes.progress} />
    <div className={classes.textContainer}>
      <h1>We've entered gnome-man's land</h1>
      <h2>
        There doesn`t seems to be a page here. <br />
        We are now returning you to our regularly scheduled program.
      </h2>
    </div>
    <div className={classes.animatedBg} />
  </div>
);
NotFoundPageComponent.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default withStyles(styles)(NotFoundPageComponent);
